import moment from 'moment-timezone'
import { SET_ALL_CYCLE_COUNT_ITEMS } from './actionType'
import { daysSincePhyscntDate } from '../../../utils/cycleCountDates'

export const initialState = {
  allCycleCountItems: {},
  lastUpdated: { allCycleCountItems: null },
}

export default function cycleCountReducer(state = initialState, action = {}) {
  const getDueList = (allItems, imCode, days) =>
    allItems.filter(
      (a) => a.imcode === imCode && daysSincePhyscntDate(a.physcntdate) >= days,
    )

  const sortByBin = (a, b) =>
    !a.binnum ? 1 : !b.binnum ? -1 : a.binnum.toString().localeCompare(b.binnum)

  const getAllItemsDue = (items) =>
    getDueList(items, 'I', 7)
      .concat(
        getDueList(items, 'H', 30),
        getDueList(items, 'M', 60),
        getDueList(items, 'L', 90),
      )
      .sort(sortByBin)

  switch (action.type) {
    case SET_ALL_CYCLE_COUNT_ITEMS: {
      const allItems = action.allCycleCountItems.sort(sortByBin)

      return {
        ...state,
        allCycleCountItems: {
          allItems,
          allItemsDue: getAllItemsDue(allItems),
          sevenDays: getDueList(allItems, 'I', 7),
          thirtyDays: getDueList(allItems, 'H', 30),
          sixtyDays: getDueList(allItems, 'M', 60),
          ninetyDays: getDueList(allItems, 'L', 90),
        },
        lastUpdated: {
          ...state.lastUpdated,
          allCycleCountItems: moment().format('LLL'),
        },
      }
    }
    default:
      return state
  }
}
